import {useEffect} from "react";
import queryString from "query-string";
import {useLocation} from "react-router-dom";
import {pick} from "ramda";

import getGoogleAnalyticsClientId from "../../analytics/helpers/getGoogleAnalyticsClientId";
import getPageName from "../../analytics/helpers/getPageName";
import {
  FREE_SUB_STATUS,
  PREMIUM_SUB_STATUS,
  REFERRING_DOMAIN,
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_MEDIUM,
  UTM_SOURCE,
  UTM_TERM,
} from "../../analytics/constants";
import {useToken} from "../../features/user/token";
import {useUser} from "../../features/user/hooks";

const AppAnalytics = () => {
  const {isSuccess: isTokenReady, data: token} = useToken();
  const user = useUser();

  const isUserReady = Boolean(isTokenReady && (!token?.account_id || user));

  const {pathname} = useLocation();

  useEffect(() => {
    if (token?.account_id && user) {
      const utm = pick(
        [UTM_SOURCE, UTM_MEDIUM, UTM_CAMPAIGN, UTM_TERM, UTM_CONTENT],
        queryString.parse(window.location.search)
      );

      window.analytics?.identify(token?.account_id, {
        externalUserId: user.externalId,
        username: user.username,
        email: user.email,
        ...utm,
        referrer: document.referrer,
        cid: getGoogleAnalyticsClientId(),
        subStatus: user.isPremium ? PREMIUM_SUB_STATUS : FREE_SUB_STATUS,
        [REFERRING_DOMAIN]:
          document.referrer && new URL(document.referrer).hostname,
      });
    }
  }, [isUserReady, user]);

  useEffect(() => {
    if (isUserReady) {
      const pageName = getPageName(pathname);

      window.analytics?.page(pageName);
    }
  }, [isUserReady, pathname]);

  return null;
};

export default AppAnalytics;
